var _g, _g2, _rect, _rect2, _rect3, _g3, _rect4, _rect5, _g4, _rect6, _rect7, _rect8, _g5, _rect9, _rect10, _g6, _rect11, _rect12, _rect13, _g7, _rect14, _rect15, _path, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodatalightyet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1462_5897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.559 146.559C150.572 142.546 153.756 137.782 155.927 132.538C158.099 127.295 159.217 121.675 159.217 116C159.217 110.325 158.099 104.705 155.927 99.4616C153.756 94.2182 150.572 89.454 146.559 85.4409C142.546 81.4278 137.782 78.2445 132.538 76.0726C127.295 73.9008 121.675 72.7829 116 72.7829C110.325 72.7829 104.705 73.9008 99.4615 76.0726C94.2182 78.2445 89.454 81.4279 85.4409 85.4409L116 116L146.559 146.559Z",
    fill: "#FFDF6F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_1462_5897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4409 85.4409C81.4278 89.454 78.2445 94.2182 76.0726 99.4615C73.9008 104.705 72.7829 110.325 72.7829 116C72.7829 121.675 73.9008 127.295 76.0726 132.538C78.2445 137.782 81.4278 142.546 85.4409 146.559C89.454 150.572 94.2182 153.755 99.4615 155.927C104.705 158.099 110.325 159.217 116 159.217C121.675 159.217 127.295 158.099 132.538 155.927C137.782 153.755 142.546 150.572 146.559 146.559L116 116L85.4409 85.4409Z",
    fill: "#FFA800"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.918,
    y: 143.245,
    width: 109.718,
    height: 40.5,
    rx: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8086,
    y: 149.136,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#959595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1462_5897",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 149,
    width: 30,
    height: 29
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8086,
    y: 149.136,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#ECEEF0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1462_5897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4453 179.327L91.6866 158.413C92.0525 157.835 92.8776 157.787 93.3083 158.318L103.148 170.458C103.532 170.931 104.245 170.954 104.659 170.508L109.953 164.794C110.392 164.32 111.159 164.381 111.518 164.918L121.154 179.327H78.4453Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.162 156.868C107.162 157.523 106.968 158.164 106.604 158.709C106.24 159.254 105.722 159.678 105.117 159.929C104.511 160.18 103.845 160.246 103.202 160.118C102.56 159.99 101.969 159.674 101.506 159.211C101.042 158.748 100.727 158.157 100.599 157.514C100.471 156.872 100.537 156.205 100.787 155.6C101.038 154.994 101.463 154.477 102.008 154.113C102.553 153.749 103.193 153.554 103.849 153.554C104.728 153.554 105.57 153.903 106.192 154.525C106.813 155.146 107.162 155.989 107.162 156.868Z",
    fill: "#C1C1C1"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.836,
    y: 157.236,
    width: 32.4,
    height: 2.94545,
    rx: 1.47272,
    fill: "#DFDFE1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 124.836,
    y: 166.809,
    width: 32.4,
    height: 2.94545,
    rx: 1.47272,
    fill: "#DFDFE1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.768 157.65C173.044 157.098 173.826 157.121 174.079 157.65L175.598 160.711L178.958 161.194C179.556 161.286 179.786 162.022 179.349 162.46L176.933 164.83L177.508 168.166C177.6 168.765 176.956 169.225 176.427 168.949L173.435 167.361L170.421 168.949C169.891 169.225 169.247 168.765 169.339 168.166L169.914 164.83L167.498 162.46C167.061 162.022 167.291 161.286 167.889 161.194L171.272 160.711L172.768 157.65Z",
    fill: "#797F8A"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.918,
    y: 47.5181,
    width: 109.718,
    height: 40.5,
    rx: 12,
    fill: "#F2F3F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8086,
    y: 53.4092,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#959595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1462_5897",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 53,
    width: 30,
    height: 30
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8086,
    y: 53.4092,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#959595"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1462_5897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4453 83.6002L91.6866 62.6858C92.0525 62.1079 92.8776 62.0597 93.3083 62.5911L103.148 74.7309C103.532 75.2038 104.245 75.2274 104.659 74.7809L109.953 69.0668C110.392 68.5929 111.159 68.6536 111.518 69.1906L121.154 83.6002H78.4453Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.162 61.1408C107.162 61.7962 106.968 62.4368 106.604 62.9818C106.24 63.5267 105.722 63.9514 105.117 64.2022C104.511 64.453 103.845 64.5186 103.202 64.3908C102.56 64.2629 101.969 63.9473 101.506 63.4839C101.042 63.0205 100.727 62.4301 100.599 61.7873C100.471 61.1445 100.537 60.4782 100.787 59.8727C101.038 59.2672 101.463 58.7497 102.008 58.3856C102.553 58.0215 103.193 57.8271 103.849 57.8271C104.728 57.8271 105.57 58.1763 106.192 58.7977C106.813 59.4191 107.162 60.262 107.162 61.1408Z",
    fill: "#C1C1C1"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 124.836,
    y: 61.5088,
    width: 32.4,
    height: 2.94546,
    rx: 1.47273,
    fill: "#DFDFE1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 124.836,
    y: 71.0815,
    width: 32.4,
    height: 2.94545,
    rx: 1.47273,
    fill: "#DFDFE1"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.768 61.9232C173.044 61.3709 173.826 61.3939 174.079 61.9232L175.598 64.9837L178.958 65.4669C179.556 65.559 179.786 66.2954 179.349 66.7326L176.933 69.1027L177.508 72.4394C177.6 73.0377 176.956 73.4979 176.427 73.2218L173.435 71.634L170.421 73.2218C169.891 73.4979 169.247 73.0377 169.339 72.4394L169.914 69.1027L167.498 66.7326C167.061 66.2954 167.291 65.559 167.889 65.4669L171.272 64.9837L172.768 61.9232Z",
    fill: "#797F8A"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0996,
    y: 95.3818,
    width: 109.718,
    height: 40.5,
    rx: 12,
    fill: "#F2F3F5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9902,
    y: 101.273,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#959595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1462_5897",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 101,
    width: 30,
    height: 29
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9902,
    y: 101.273,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1462_5897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.627 131.464L54.8682 110.55C55.2341 109.972 56.0592 109.923 56.49 110.455L66.33 122.595C66.7133 123.068 67.4266 123.091 67.8403 122.645L73.135 116.931C73.5741 116.457 74.3406 116.517 74.6998 117.054L84.336 131.464H41.627Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3441 109.005C70.3441 109.66 70.1497 110.301 69.7856 110.846C69.4215 111.39 68.904 111.815 68.2985 112.066C67.693 112.317 67.0268 112.382 66.384 112.255C65.7412 112.127 65.1508 111.811 64.6873 111.348C64.2239 110.884 63.9083 110.294 63.7805 109.651C63.6526 109.008 63.7182 108.342 63.969 107.736C64.2198 107.131 64.6445 106.613 65.1895 106.249C65.7344 105.885 66.3751 105.691 67.0304 105.691C67.9093 105.691 68.7521 106.04 69.3735 106.661C69.995 107.283 70.3441 108.126 70.3441 109.005Z",
    fill: "#C1C1C1"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 88.0176,
    y: 109.373,
    width: 32.4,
    height: 2.94546,
    rx: 1.47273,
    fill: "#505357"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 88.0176,
    y: 118.945,
    width: 32.4,
    height: 2.94545,
    rx: 1.47272,
    fill: "#505357"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.949 109.787C136.226 109.235 137.008 109.258 137.261 109.787L138.78 112.847L142.14 113.331C142.738 113.423 142.968 114.159 142.531 114.596L140.115 116.967L140.69 120.303C140.782 120.901 140.138 121.362 139.608 121.086L136.617 119.498L133.602 121.086C133.073 121.362 132.429 120.901 132.521 120.303L133.096 116.967L130.68 114.596C130.243 114.159 130.473 113.423 131.071 113.331L134.454 112.847L135.949 109.787Z",
    fill: "#FAC402"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1462_5897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.757 133.93C142.499 133.599 142.177 132.927 141.615 132.089C141.293 131.629 140.502 130.754 140.262 130.303C140.09 130.029 140.04 129.696 140.124 129.383C140.269 128.789 140.833 128.394 141.44 128.463C141.911 128.557 142.343 128.787 142.683 129.125C142.921 129.349 143.139 129.592 143.337 129.852C143.484 130.037 143.521 130.11 143.686 130.322C143.852 130.534 143.962 130.745 143.88 130.432C143.815 129.972 143.705 129.199 143.548 128.509C143.429 127.984 143.401 127.901 143.291 127.505C143.18 127.109 143.116 126.778 142.996 126.327C142.887 125.884 142.801 125.435 142.738 124.983C142.622 124.405 142.707 123.804 142.978 123.28C143.299 122.978 143.771 122.898 144.174 123.078C144.58 123.377 144.882 123.796 145.039 124.274C145.281 124.864 145.442 125.483 145.518 126.115C145.665 127.036 145.951 128.38 145.96 128.656C145.96 128.315 145.895 127.597 145.96 127.275C146.024 126.939 146.257 126.661 146.577 126.539C146.851 126.455 147.141 126.436 147.423 126.484C147.709 126.543 147.962 126.707 148.132 126.944C148.345 127.481 148.464 128.051 148.482 128.628C148.507 128.123 148.593 127.622 148.74 127.137C148.893 126.92 149.118 126.764 149.375 126.695C149.679 126.64 149.991 126.64 150.295 126.695C150.545 126.779 150.763 126.936 150.921 127.146C151.116 127.634 151.234 128.15 151.271 128.674C151.271 128.803 151.335 128.315 151.538 127.993C151.643 127.681 151.907 127.448 152.23 127.383C152.553 127.318 152.887 127.43 153.105 127.678C153.322 127.925 153.392 128.27 153.287 128.582C153.287 129.181 153.287 129.153 153.287 129.558C153.287 129.963 153.287 130.322 153.287 130.662C153.253 131.201 153.179 131.736 153.066 132.264C152.906 132.731 152.683 133.174 152.403 133.58C151.956 134.077 151.587 134.639 151.308 135.246C151.238 135.548 151.208 135.857 151.216 136.167C151.215 136.453 151.252 136.737 151.326 137.014C150.95 137.053 150.57 137.053 150.194 137.014C149.835 136.958 149.393 136.24 149.273 136.019C149.214 135.901 149.093 135.826 148.961 135.826C148.828 135.826 148.707 135.901 148.648 136.019C148.445 136.369 147.994 137.004 147.681 137.041C147.064 137.115 145.794 137.041 144.791 137.041C144.791 137.041 144.957 136.121 144.579 135.789C144.202 135.458 143.815 135.071 143.53 134.814L142.757 133.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.757 133.93C142.499 133.599 142.177 132.927 141.615 132.089C141.293 131.629 140.502 130.754 140.262 130.303C140.09 130.029 140.04 129.696 140.124 129.383C140.269 128.789 140.833 128.394 141.44 128.463C141.911 128.557 142.343 128.787 142.683 129.125C142.921 129.349 143.139 129.592 143.337 129.852C143.484 130.037 143.521 130.11 143.686 130.322C143.852 130.534 143.962 130.745 143.88 130.432C143.815 129.972 143.705 129.199 143.548 128.509C143.429 127.984 143.401 127.901 143.291 127.505C143.18 127.109 143.116 126.778 142.996 126.327C142.887 125.884 142.801 125.435 142.738 124.983C142.622 124.405 142.707 123.804 142.978 123.28C143.299 122.978 143.771 122.898 144.174 123.078C144.58 123.377 144.882 123.796 145.039 124.274C145.281 124.864 145.442 125.483 145.518 126.115C145.665 127.036 145.951 128.38 145.96 128.656C145.96 128.315 145.895 127.597 145.96 127.275C146.024 126.939 146.257 126.661 146.577 126.539C146.851 126.455 147.141 126.436 147.423 126.484C147.709 126.543 147.962 126.707 148.132 126.944C148.345 127.481 148.464 128.051 148.482 128.628C148.507 128.123 148.593 127.622 148.74 127.137C148.893 126.92 149.118 126.764 149.375 126.695C149.679 126.64 149.991 126.64 150.295 126.695C150.545 126.779 150.763 126.936 150.921 127.146C151.116 127.634 151.234 128.15 151.271 128.674C151.271 128.803 151.335 128.315 151.538 127.993C151.643 127.681 151.907 127.448 152.23 127.383C152.553 127.318 152.887 127.43 153.105 127.678C153.322 127.925 153.392 128.27 153.287 128.582C153.287 129.181 153.287 129.153 153.287 129.558C153.287 129.963 153.287 130.322 153.287 130.662C153.253 131.201 153.179 131.736 153.066 132.264C152.906 132.731 152.683 133.174 152.403 133.58C151.956 134.077 151.587 134.639 151.308 135.246C151.238 135.548 151.208 135.857 151.216 136.167C151.215 136.453 151.252 136.737 151.326 137.014C150.95 137.053 150.57 137.053 150.194 137.014C149.835 136.958 149.393 136.24 149.273 136.019C149.214 135.901 149.093 135.826 148.961 135.826C148.828 135.826 148.707 135.901 148.648 136.019C148.445 136.369 147.994 137.004 147.681 137.041C147.064 137.115 145.794 137.041 144.791 137.041C144.791 137.041 144.957 136.121 144.579 135.789C144.202 135.458 143.815 135.071 143.53 134.814L142.757 133.93Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.561 134.433V131.255C150.561 131.065 150.407 130.911 150.216 130.911C150.026 130.911 149.871 131.065 149.871 131.255V134.433C149.871 134.623 150.026 134.777 150.216 134.777C150.407 134.777 150.561 134.623 150.561 134.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.74 134.432L148.722 131.253C148.72 131.063 148.565 130.91 148.374 130.911C148.184 130.912 148.03 131.067 148.031 131.257L148.05 134.435C148.051 134.625 148.206 134.778 148.397 134.777C148.587 134.776 148.741 134.621 148.74 134.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.189 131.26L146.208 134.432C146.209 134.624 146.364 134.778 146.555 134.777C146.746 134.776 146.899 134.62 146.898 134.428L146.88 131.256C146.879 131.064 146.723 130.91 146.533 130.911C146.342 130.912 146.188 131.068 146.189 131.26Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1462_5897",
    x: 13.4414,
    y: 0.782715,
    width: 217.775,
    height: 217.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36,
    result: "effect1_foregroundBlur_1462_5897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1462_5897",
    x: 0.783203,
    y: 13.4409,
    width: 217.775,
    height: 217.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36,
    result: "effect1_foregroundBlur_1462_5897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1462_5897",
    x: 138.909,
    y: 122.608,
    width: 15.602,
    height: 16.6408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1462_5897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1462_5897",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodatalightyet);
export default __webpack_public_path__ + "static/media/nodatalightyet.324f55fcaf4d45f89ab2f8e17d54cbea.svg";
export { ForwardRef as ReactComponent };